import React, { useEffect, useState } from "react";
import { Flex, notification, InputNumber, Select } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  list,
  addeditdata,
} from "../../../controllers/V1/users/usersController";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import SelectUsers from "../../../components/SelectUsers";
import { round, toFixed } from "../../../utils/bigMath";

const formatBPoints = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const formatted = toFixed(value, 2);
  return formatted === "-" ? "" : formatted;
};

const normalizeBPointsState = (data) => {
  if (!data) return data;
  return {
    ...data,
    ...(data.totalArabianPoints != null &&
      data.totalArabianPoints !== "" && {
        totalArabianPoints: round(data.totalArabianPoints, 2),
      }),
    ...(data.availableArabianPoints != null &&
      data.availableArabianPoints !== "" && {
        availableArabianPoints: round(data.availableArabianPoints, 2),
      }),
  };
};

const UserListEditPage = () => {
  const { Option } = Select;
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditData] = useState(
    normalizeBPointsState(state) || {
      voucher_commission: 10,
      commission_percentage: 10,
      // redeem_limit : 100,
      redeem_limit_amount: 100,
    },
  );
  const [allCountryList, setAllCountryList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is use to handle input change
   *********************************************************/
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "lotto_games") {
      setAddEditData((pre) => ({
        ...pre,
        [name]: ADDEDITDATA?.lotto_games === "Y" ? "N" : "Y",
      }));
    } else if (name === "lotto_games_2") {
      setAddEditData((pre) => ({
        ...pre,
        [name]: ADDEDITDATA?.lotto_games_2 === "Y" ? "N" : "Y",
      }));
    } else if (name === "pickup_point_holder") {
      setAddEditData((pre) => ({
        ...pre,
        [name]: ADDEDITDATA?.pickup_point_holder === "Y" ? "N" : "Y",
      }));
    } else if (name === "enable_dis_voucher_ecomm") {
      setAddEditData((pre) => ({
        ...pre,
        [name]: ADDEDITDATA?.enable_dis_voucher_ecomm === "Y" ? "N" : "Y",
      }));
    } else if (name === "enable_dis_voucher_ecomm_2") {
      setAddEditData((pre) => ({
        ...pre,
        [name]: ADDEDITDATA?.enable_dis_voucher_ecomm_2 === "Y" ? "N" : "Y",
      }));
    } else if (name === "enable_dual_login") {
      // setAddEditData((pre) => ({
      //   ...pre,
      //   [name]: ADDEDITDATA?.enable_dual_login === "Y" ? "N" : "Y",
      // }));
      setAddEditData((pre) => {
      const newValue = pre.enable_dual_login === "Y" ? "N" : "Y";
      return {
          ...pre,
          enable_dual_login: newValue,
          ...(newValue === "N" && {
            enable_dis_voucher_ecomm_2: "N",
            lotto_games_2: "N",
          }),
        };
      });
    } else if (name === "bind_user_type") {
      setAddEditData((pre) => ({
        ...pre,
        [name]: value,
        bind_person_id: "",
        bind_person_name: "",
        bind_person_mobile: "",
      }));
    } else if (name === "smart_rtp_games") {
      setAddEditData((pre) => ({
        ...pre,
        [name]: ADDEDITDATA?.smart_rtp_games === "Y" ? "N" : "Y",
      }));
    } else {
      setAddEditData((pre) => ({
        ...pre,
        [name]: value,
      }));
    }
    setError((pre) => ({
      ...pre,
      [name]: "",
    }));
    if (name === "users_email") {
      if (emailDebounceTimer) {
        clearTimeout(emailDebounceTimer);
      }

      // Set new debounce timer
      const timer = setTimeout(() => {
        checkDuplicateEmail(value);
      }, 2000); // 2.5 seconds

      setEmailDebounceTimer(timer);
    }
  };
  const [emailDebounceTimer, setEmailDebounceTimer] = useState(null);
  /*********************************************************
   *  This function is used to handle phone number change
   *********************************************************/
  const checkDuplicateEmail = async (email) => {
    try {
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!isEmail) return;
      const option = {
        type: "single",
        condition: { users_email: email },
        select: { _id: true },
      };
      const data = await list(option);
      if (data?.status && data.result?._id) {
        // If editing, check that the found email is not from the current user
        if (!ADDEDITDATA?._id || data.result._id !== ADDEDITDATA._id) {
          setError((prev) => ({
            ...prev,
            users_email: `${email} already exists.`,
          }));
        }
      }
    } catch (error) {}
  };

  const checkDuplicateEmailOnSubmit = async (email) => {
    const option = {
      type: "single",
      condition: { users_email: email },
      select: { _id: true },
    };

    const data = await list(option);

    if (data?.status && data.result?._id) {
      if (!ADDEDITDATA?._id || data.result._id !== ADDEDITDATA._id) {
        return true; // duplicate exists
      }
    }

    return false;
  };
  /*********************************************************
   *  This function is used to handle phone number change
   *********************************************************/
  const handlePhoneChange = (value) => {
    setAddEditData((prev) => ({
      ...prev,
      users_mobile: value,
    }));
    setError((prev) => ({
      ...prev,
      users_mobile: "",
    }));
  };
  /*********************************************************
   *  This function is used to handle phone code change
   *********************************************************/
  const handlePhoneCodeChange = (value) => {
    setAddEditData((prev) => ({
      ...prev,
      country_code: value,
    }));
    const data = value?.split("___");
    setCountryInfo({
      name: data[1],
      dialCode: data[0],
    });
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();

    const form = new FormData(event.target);
    const email = form.get("users_email");
    if(email){
      const isDuplicate = await checkDuplicateEmailOnSubmit(email);
      if (isDuplicate) {
        setError((prev) => ({
          ...prev,
          users_email: `${email} already exists.`,
        }));

        notification.open({
          message: "Oops!",
          description: `${email} already exists.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });

        return; // ⛔ STOP API CALL
      }
    }
    try {
      setIsLoading(true);
      // const form = new FormData(event.target);
      const users_type = form.get("users_type");
      const country_code = form.get("country_code")?.split("___");
      const params = {
        edit_id: form.get("edit_id"),
        users_type: users_type,
        users_name: form.get("users_name"),
        last_name: form.get("last_name"),
        country_code: country_code[0],
        users_mobile: form.get("users_mobile"),
        users_email: form.get("users_email"),
        area: form.get("area"),
        totalArabianPoints: round(form.get("totalArabianPoints") || 0, 2),
        availableArabianPoints: round(form.get("availableArabianPoints") || 0, 2),
        pickup_point_holder: ADDEDITDATA?.pickup_point_holder || "N",
        smart_rtp_games: form.get("smart_rtp_games") || "N",
        // redeem_limit            : form.get('redeem_limit') || 0,
        rtp_redeem_limit: form.get("rtp_redeem_limit") || 19,
        lotto_pin: form.get("lotto_pin") || "",
        lotto_games: form.get("lotto_games") || "N",
        lotto_games_2: form.get("lotto_games_2") || "N",
        contract_given_by: form.get("contract_given_by") || "",

        // ...(['Retailer','Sales Person','Freelancer','Promoter'].includes(ADDEDITDATA?.users_type) ? { big_winners_redeem : ADDEDITDATA?.big_winners_redeem === 'Y'?'Y':'N' }:{big_winners_redeem : 'N'}),

        ...(form.get("password") && { password: form.get("password") }),
        ...(form.get("otp") && { otp: form.get("otp") }),
        // ...(form.get('pos_serial_id')&&{pos_serial_id : form.get('pos_serial_id')}),
        pos_serial_id: form.get("pos_serial_id") || "",
        pos_serial_id_2: form.get("pos_serial_id_2") || "",

        ...((users_type === "Retailer" || users_type === "Promoter") && {
          store_name: form.get("store_name"),
        }),
        ...((users_type === "Freelancer" ||
          users_type === "Sales Person" ||
          users_type === "Retailer" ||
          users_type === "Promoter") && {
          // pos_number            : form.get('pos_number'),
          // pos_device_id         : form.get('pos_device_id'),
          commission_percentage: form.get("commission_percentage") || 10,
          voucher_commission: form.get("voucher_commission") || 10,
          product_commission: form.get("product_commission") || 10,
          redeem_limit_amount: form.get("redeem_limit_amount") || 100,
          ...(form.get("full_address") && {
            full_address: form.get("full_address") || "",
          }),
          enable_dual_login : form.get("enable_dual_login") || 'N'
        }),

        ...((users_type === "Freelancer" ||
          users_type === "Retailer" ||
          users_type === "Promoter") && {
          bind_user_type:
            users_type === "Freelancer"
              ? "Sales Person"
              : form.get("bind_user_type"),
          bind_person_name: form.get("bind_person_name"),
          bind_person_mobile: form.get("bind_person_mobile"),
          bind_person_id: form.get("bind_person_id"),
        }),
        ...(users_type === "Retailer" && {
          enable_dis_voucher_ecomm: form.get("enable_dis_voucher_ecomm"),
          enable_dis_voucher_ecomm_2: form.get("enable_dis_voucher_ecomm_2"),
        }),
      };
      const isValidate = await validateFormData(params);
      if (isValidate === true) {
        const res = await addeditdata(params);
        if (res.status === true) {
          notification.open({
            message: "Success.",
            description: `Data successfully added.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/users/list");
        } else {
          notification.open({
            message: "Oops!.",
            description: `${res.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        // console.log('validation error',error);
        notification.open({
          message: "Oops!",
          description: `Validation Error.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    try {
      const {
        users_type,
        users_name,
        last_name,
        area,
        users_mobile,
        users_email,
        store_name,
        commission_percentage,
        bind_user_type,
        bind_person_name,
        bind_person_id,
        bind_person_mobile,
        password,
        confirm_password,
        otp,
      } = formData;
      let status = false;
      let msg = "noError";
      let error_field = "noError";
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      if (!users_type) {
        error_field = "users_type";
        msg = "User's type is required";
        status = false;
      } else if (!users_name) {
        error_field = "users_name";
        msg = "First name is required";
        status = false;
      } else if (!last_name) {
        error_field = "last_name";
        msg = "Last name is required";
        status = false;
      } else if (!area) {
        error_field = "area";
        msg = "Area is required";
        status = false;
      } else if (!users_mobile) {
        error_field = "users_mobile";
        msg = "Phone number is required";
        status = false;
      } else if (users_email && !emailRegex.test(users_email)) {
        error_field = "users_email";
        msg = "Inavlid email address";
        status = false;
      } else if (
        (password || confirm_password) &&
        password === confirm_password
      ) {
        error_field = "password";
        msg = "Password and confirm password should be same.";
        status = false;
      } else if ((password || confirm_password) && password.length < 4) {
        error_field = "password";
        msg = "Password should be greater than 3 character.";
        status = false;
      } else if (otp && otp.length !== 6) {
        error_field = "otp";
        msg = "One Time Password OTP should be 6 digits.";
        status = false;
      } else if (
        (users_type === "Retailer" || users_type === "Promoter") &&
        !store_name
      ) {
        error_field = "store_name";
        msg = "Store name is required";
        status = false;
        // } else if((users_type === 'Freelancer' || users_type === 'Promoter' || users_type === 'Sales Person') && (!pos_number)){
        //   error_field = 'pos_number';
        //   msg = "POS Number is required";
        //   status = false;
        // } else if((users_type === 'Freelancer' || users_type === 'Promoter' || users_type === 'Sales Person') && (!pos_device_id)){
        //   error_field = 'pos_device_id';
        //   msg = "POS device id is required";
        //   status = false;
      } else if (
        (users_type === "Freelancer" ||
          users_type === "Sales Person" ||
          users_type === "Retailer" ||
          users_type === "Promoter") &&
        !commission_percentage
      ) {
        error_field = "commission_percentage";
        msg = "Commission percentage is required";
        status = false;
      } else if (
        (users_type === "Freelancer" ||
          users_type === "Retailer" ||
          users_type === "Promoter") &&
        !bind_user_type
      ) {
        error_field = "bind_user_type";
        msg = "Bind user type is required";
        status = false;
      } else if (
        (users_type === "Freelancer" ||
          users_type === "Retailer" ||
          users_type === "Promoter") &&
        !bind_person_name
      ) {
        error_field = "bind_with_user";
        msg = "Bind person name is required";
        status = false;
      } else if (
        (users_type === "Freelancer" ||
          users_type === "Retailer" ||
          users_type === "Promoter") &&
        !bind_person_id
      ) {
        error_field = "bind_with_user";
        msg = "Bind person id is required";
        status = false;
      } else if (
        (users_type === "Freelancer" ||
          users_type === "Retailer" ||
          users_type === "Promoter") &&
        !bind_person_mobile
      ) {
        error_field = "bind_with_user";
        msg = "Bind person mobile is required";
        status = false;
      } else {
        status = true;
      }
      if (!status && setError) {
        setError((prevError) => ({
          ...prevError,
          [error_field]: msg,
        }));
      }
      return status;
    } catch (error) {
      console.log("error", error);
      return false;
    }
  };
  const [countryInfo, setCountryInfo] = useState({});
  useEffect(() => {
    import("../../../controllers/flag_json.json")
      .then((list) => {
        setAllCountryList(list.default); // Access default export when using `import`
        const countryData = list.default.find(
          (item) => item.dialCode === `${state?.country_code || "+973"}`,
        );
        if (countryData) {
          setCountryInfo(countryData);
        } else {
          setCountryInfo({
            name: "Bahrain",
            dialCode: "+973",
          });
        }
      })
      .catch((error) => console.error("Error loading JSON:", error));
      
      console.log('state', state);

    document.title = `Crown King || ${
      ADDEDITDATA?._id ? "Edit" : "Add"
    } Users`;
  }, []);

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading">
              {" "}
              {ADDEDITDATA?._id ? `Edit` : `Add`} User{" "}
            </h5>
          </React.Fragment>
          <Link to={"/users/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary">
                {" "}
                <ArrowLeftOutlined /> Back{" "}
              </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form
                method="post"
                className="inventory_form_main_contnet"
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                <input
                  type="hidden"
                  name="edit_id"
                  id="edit_id"
                  value={ADDEDITDATA._id || ""}
                />
                <input
                  type="hidden"
                  name="country_code"
                  id="country_code"
                  value={ADDEDITDATA?.country_code || "+973"}
                />
                <input
                  type="hidden"
                  name="users_mobile"
                  id="users_mobile"
                  value={ADDEDITDATA?.users_mobile || ""}
                />

                <input
                  type="hidden"
                  name="bind_person_name"
                  id="bind_person_name"
                  value={ADDEDITDATA?.bind_person_name || ""}
                />
                <input
                  type="hidden"
                  name="bind_user_type"
                  id="bind_user_type"
                  value={ADDEDITDATA?.bind_user_type || ""}
                />
                <input
                  type="hidden"
                  name="bind_person_id"
                  id="bind_person_id"
                  value={ADDEDITDATA?.bind_person_id || ""}
                />
                <input
                  type="hidden"
                  name="bind_person_mobile"
                  id="bind_person_mobile"
                  value={ADDEDITDATA?.bind_person_mobile || ""}
                />

                <div className="row">
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="users_type"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>User's Type :{" "}
                    </label>
                    <select
                      name="users_type"
                      id="users_type"
                      class="form-control store_input_field"
                      onChange={handleChange}
                    >
                      <option value="" selected disabled>
                        Select user type
                      </option>
                      <option
                        value="Freelancer"
                        selected={
                          ADDEDITDATA?.users_type === "Freelancer"
                            ? true
                            : false
                        }
                      >
                        Freelancer
                      </option>
                      <option
                        value="Sales Person"
                        selected={
                          ADDEDITDATA?.users_type === "Sales Person"
                            ? true
                            : false
                        }
                      >
                        Sales Person
                      </option>
                      <option
                        value="Retailer"
                        selected={
                          ADDEDITDATA?.users_type === "Retailer" ? true : false
                        }
                      >
                        Retailer
                      </option>
                      <option
                        value="Promoter"
                        selected={
                          ADDEDITDATA?.users_type === "Promoter" ? true : false
                        }
                      >
                        Promoter
                      </option>
                      <option
                        value="Users"
                        selected={
                          ADDEDITDATA?.users_type === "Users" ? true : false
                        }
                      >
                        Users
                      </option>
                      <option
                        value="Tester"
                        selected={
                          ADDEDITDATA?.users_type === "Tester" ? true : false
                        }
                      >
                        Tester
                      </option>
                    </select>
                    {error.users_type ? (
                      <p style={{ color: "red" }}>{error.users_type}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="users_name"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>First Name :{" "}
                    </label>
                    <input
                      title="Enter your first name."
                      placeholder="Enter your first name."
                      type="text"
                      name="users_name"
                      className="form-control store_input_field"
                      id="users_name"
                      value={ADDEDITDATA?.users_name}
                      onChange={handleChange}
                    />
                    {error.users_name ? (
                      <p style={{ color: "red" }}>{error.users_name}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="last_name"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Last Name :{" "}
                    </label>
                    <input
                      title="Enter your last name."
                      placeholder="Enter your last name."
                      type="text"
                      name="last_name"
                      className="form-control store_input_field"
                      id="last_name"
                      value={ADDEDITDATA?.last_name}
                      onChange={handleChange}
                    />
                    {error.last_name ? (
                      <p style={{ color: "red" }}>{error.last_name}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="area"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Area :{" "}
                    </label>
                    <input
                      title="Area"
                      placeholder="Area"
                      type="text"
                      name="area"
                      className="form-control store_input_field"
                      id="area"
                      value={ADDEDITDATA?.area}
                      onChange={handleChange}
                    />
                    {error.area ? (
                      <p style={{ color: "red" }}>{error.area}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="totalArabianPoints"
                      className="all_section_for_label_main_class"
                    >
                      Total QR-Points :
                    </label>
                    <input
                      title="Total QR-Points"
                      placeholder="Total Area"
                      type="number"
                      step="0.01"
                      name="totalArabianPoints"
                      className="form-control store_input_field"
                      id="totalArabianPoints"
                      value={
                        ADDEDITDATA?._id
                          ? formatBPoints(ADDEDITDATA?.totalArabianPoints)
                          : ADDEDITDATA?.totalArabianPoints ?? ""
                      }
                      disabled={ADDEDITDATA?._id ? true : false}
                      onChange={handleChange}
                    />
                    {error.totalArabianPoints ? (
                      <p style={{ color: "red" }}>{error.totalArabianPoints}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="availableArabianPoints"
                      className="all_section_for_label_main_class"
                    >
                      Available QR-Points :
                    </label>
                    <input
                      title="Available QR-Points"
                      placeholder="Available QR-Points"
                      type="number"
                      step="0.01"
                      name="availableArabianPoints"
                      className="form-control store_input_field"
                      id="availableArabianPoints"
                      value={
                        ADDEDITDATA?._id
                          ? formatBPoints(ADDEDITDATA?.availableArabianPoints)
                          : ADDEDITDATA?.availableArabianPoints ?? ""
                      }
                      disabled={ADDEDITDATA?._id ? true : false}
                      onChange={handleChange}
                    />
                    {error.availableArabianPoints ? (
                      <p style={{ color: "red" }}>
                        {error.availableArabianPoints}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="admin_phone"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Phone Number:
                    </label>
                    <br />
                    <InputNumber
                      style={{ width: "100%" }}
                      onChange={handlePhoneChange}
                      addonBefore={
                        <Select
                          showSearch={true}
                          value={`${countryInfo?.dialCode} (${countryInfo?.name})`}
                          style={{ width: "100%" }}
                          onChange={handlePhoneCodeChange}
                        >
                          {allCountryList?.length > 0 ? (
                            allCountryList.map((item) => (
                              <Option
                                value={`${item?.dialCode}___${item?.name}`}
                                selected={
                                  item.dialCode === countryInfo?.dialCode
                                }
                              >
                                {" "}
                                {item?.dialCode} ({item?.name}){" "}
                              </Option>
                            ))
                          ) : (
                            <Option value="+973" selected={true}>
                              {" "}
                              +973 (Bahrain){" "}
                            </Option>
                          )}
                        </Select>
                      }
                      value={ADDEDITDATA?.users_mobile}
                    />
                    {error.users_mobile ? (
                      <p style={{ color: "red" }}>{error.users_mobile}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="users_email"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Email Address :{" "}
                    </label>
                    <input
                      title="Email address"
                      placeholder="Email address"
                      type="text"
                      name="users_email"
                      className="form-control store_input_field"
                      id="users_email"
                      value={ADDEDITDATA?.users_email}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {error.users_email ? (
                      <p style={{ color: "red" }}>{error.users_email}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="password"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Password :{" "}
                    </label>
                    <input
                      title="Password"
                      placeholder="Password"
                      type="password"
                      name="password"
                      className="form-control store_input_field"
                      id="password"
                    />
                    {error.password ? (
                      <p style={{ color: "red" }}>{error.password}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="confirm_password"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Confirm Password :{" "}
                    </label>
                    <input
                      title="Confirm password"
                      placeholder="Confirm password"
                      type="password"
                      name="confirm_password"
                      className="form-control store_input_field"
                      id="confirm_password"
                    />
                    {error.confirm_password ? (
                      <p style={{ color: "red" }}>{error.confirm_password}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="otp"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      One Time Password (OTP) :{" "}
                    </label>
                    <input
                      onChange={handleChange}
                      title="One Time Password (OTP)"
                      placeholder="One Time Password (OTP)"
                      type="number"
                      name="otp"
                      className="form-control store_input_field"
                      id="otp"
                      value={
                        ADDEDITDATA?.otp
                          ? ADDEDITDATA.otp
                          : ADDEDITDATA?.users_otp
                      }
                    />
                    {error.otp ? (
                      <p style={{ color: "red" }}>{error.otp}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  {(ADDEDITDATA?.users_type === "Freelancer" ||
                    ADDEDITDATA?.users_type === "Retailer" ||
                    ADDEDITDATA?.users_type === "Promoter") && (
                    <>
                      <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="users_email"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          <span style={{ color: "red" }}>*</span>Bind With :
                        </label>
                        <select
                          name="bind_user_type"
                          id="bind_user_type"
                          class="form-control store_input_field"
                          onChange={handleChange}
                        >
                          <option value="" selected disabled>
                            Choose user type
                          </option>
                          {ADDEDITDATA?.users_type === "Freelancer" ? (
                            <>
                              <option
                                value="Sales Person"
                                selected={
                                  ADDEDITDATA?.bind_user_type === "Sales Person"
                                    ? true
                                    : false
                                }
                              >
                                Sales Person
                              </option>
                            </>
                          ) : (
                            <>
                              <option
                                value="Freelancer"
                                selected={
                                  ADDEDITDATA?.bind_user_type === "Freelancer"
                                    ? true
                                    : false
                                }
                              >
                                Freelancer
                              </option>
                              <option
                                value="Sales Person"
                                selected={
                                  ADDEDITDATA?.bind_user_type === "Sales Person"
                                    ? true
                                    : false
                                }
                              >
                                Sales Person
                              </option>
                            </>
                          )}
                        </select>
                        {error.bind_user_type ? (
                          <p style={{ color: "red" }}>{error.bind_user_type}</p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="bind_with_user"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          <span style={{ color: "red" }}>*</span>Select bind
                          with user :
                        </label>
                        <SelectUsers
                          setAddEditData={setAddEditData}
                          defaultSelect={
                            ADDEDITDATA._id
                              ? {
                                  label: `${ADDEDITDATA.bind_person_name}  | ${ADDEDITDATA.bind_person_mobile}`,
                                  value: JSON.stringify({
                                    _id: ADDEDITDATA.bind_person_id,
                                    users_name: ADDEDITDATA.users_name,
                                    last_name: ADDEDITDATA.last_name,
                                    users_mobile: ADDEDITDATA.users_mobile,
                                  }),
                                }
                              : {}
                          }
                          user_type={ADDEDITDATA?.bind_user_type || ""}
                        />
                        {error.bind_with_user ? (
                          <p style={{ color: "red" }}>{error.bind_with_user}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  )}

                  {(ADDEDITDATA?.users_type === "Retailer" ||
                    ADDEDITDATA?.users_type === "Promoter") && (
                    <>
                      <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="store_name"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          <span style={{ color: "red" }}>*</span>Store Name :
                        </label>
                        <input
                          title="Store Name"
                          placeholder="Store Name"
                          type="text"
                          name="store_name"
                          className="form-control store_input_field"
                          id="store_name"
                          value={ADDEDITDATA?.store_name}
                          onChange={handleChange}
                        />
                        {error.store_name ? (
                          <p style={{ color: "red" }}>{error.store_name}</p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="full_address"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          <span style={{ color: "red" }}>*</span>Pickup Point
                          Address :
                        </label>
                        <input
                          title="Pickup Point Address"
                          placeholder="Enter Pickup Point Address."
                          type="text"
                          name="full_address"
                          className="form-control store_input_field"
                          id="full_address"
                          value={ADDEDITDATA?.full_address}
                          onChange={handleChange}
                        />
                        {error.full_address ? (
                          <p style={{ color: "red" }}>{error.full_address}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  )}

                  {(ADDEDITDATA?.users_type === "Freelancer" ||
                    ADDEDITDATA?.users_type === "Sales Person" ||
                    ADDEDITDATA?.users_type === "Retailer" ||
                    ADDEDITDATA?.users_type === "Promoter") && (
                    <>
                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="lotto_pin"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          {" "}
                          Lotto Pin :{" "}
                        </label>
                        <input
                          title="Lotto Pin"
                          placeholder="Lotto Pin"
                          type="Number"
                          name="lotto_pin"
                          className="form-control store_input_field"
                          id="lotto_pin"
                        />
                        {error.lotto_pin ? (
                          <p style={{ color: "red" }}>{error.lotto_pin}</p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="pos_number"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          {" "}
                          POS Number :{" "}
                        </label>
                        <input
                          title="POS Number"
                          placeholder="POS Number"
                          type="Number"
                          name="pos_number"
                          className="form-control store_input_field"
                          id="pos_number"
                          value={ADDEDITDATA?.pos_number}
                          readOnly
                          // onChange={handleChange}
                        />
                        {error.pos_number ? (
                          <p style={{ color: "red" }}>{error.pos_number}</p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="pos_serial_id"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          {" "}
                          POS Serial Id (Device 1) :{" "}
                        </label>
                        <input
                          title="POS Serial Id"
                          placeholder="POS Serial Id"
                          type="text"
                          name="pos_serial_id"
                          className="form-control store_input_field"
                          id="pos_serial_id"
                          value={ADDEDITDATA?.pos_serial_id}
                          // readOnly
                          onChange={handleChange}
                        />
                        {error.pos_serial_id ? (
                          <p style={{ color: "red" }}>{error.pos_serial_id}</p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="pos_serial_id_2"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          {" "}
                          POS Serial Id (Device 2) :{" "}
                        </label>
                        <input
                          title="POS Serial Id"
                          placeholder="POS Serial Id"
                          type="text"
                          name="pos_serial_id_2"
                          className="form-control store_input_field"
                          id="pos_serial_id_2"
                          value={ADDEDITDATA?.pos_serial_id_2}
                          // readOnly
                          onChange={handleChange}
                        />
                        {error.pos_serial_id_2 ? (
                          <p style={{ color: "red" }}>{error.pos_serial_id_2}</p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="commission_percentage"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          <span style={{ color: "red" }}>*</span>Commission
                          Percentage :
                        </label>
                        <input
                          title="Commission Percentage"
                          placeholder="Commission Percentage"
                          type="number"
                          name="commission_percentage"
                          className="form-control store_input_field"
                          id="commission_percentage"
                          value={ADDEDITDATA?.commission_percentage}
                          onChange={handleChange}
                        />
                        {error.commission_percentage ? (
                          <p style={{ color: "red" }}>
                            {error.commission_percentage}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="commission_percentage"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          <span style={{ color: "red" }}>*</span>Voucher
                          Commission :
                        </label>
                        <input
                          title="Voucher Commission Percentage"
                          placeholder="Voucher Commission Percentage"
                          type="number"
                          name="voucher_commission"
                          className="form-control store_input_field"
                          id="voucher_commission"
                          value={ADDEDITDATA?.voucher_commission}
                          onChange={handleChange}
                        />
                        {error.voucher_commission ? (
                          <p style={{ color: "red" }}>
                            {error.voucher_commission}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="product_commission"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          <span style={{ color: "red" }}>*</span>Product
                          Commission :
                        </label>
                        <input
                          title="Product Commission Percentage"
                          placeholder="Product Commission Percentage"
                          type="number"
                          name="product_commission"
                          className="form-control store_input_field"
                          id="product_commission"
                          value={ADDEDITDATA?.product_commission}
                          onChange={handleChange}
                        />
                        {error.product_commission ? (
                          <p style={{ color: "red" }}>
                            {error.product_commission}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  )}

                  {[
                    "Retailer",
                    "Sales Person",
                    "Freelancer",
                    "Promoter",
                  ].includes(ADDEDITDATA?.users_type) && (
                    <>
                      {/* <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="redeem_limit" className="all_section_for_label_main_class all_lebel_margin_top_main_div">Redeem Limit (Count) </label>
                      <input
                        type="text"
                        id="redeem_limit"
                        name="redeem_limit"
                        className="form-control store_input_field"
                        placeholder="Redeem limit"
                        value={ADDEDITDATA?.redeem_limit}
                        onChange={handleChange}
                      />
                    </div> */}

                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="rtp_redeem_limit"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          RTP Redeem Limit (Amount){" "}
                        </label>
                        <input
                          type="text"
                          id="rtp_redeem_limit"
                          name="rtp_redeem_limit"
                          className="form-control store_input_field"
                          placeholder="RTP Redeem limit amount"
                          value={ADDEDITDATA?.rtp_redeem_limit}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="rtp_redeem_limit"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          Redeem Limit (Amount){" "}
                        </label>
                        <input
                          type="text"
                          id="redeem_limit_amount"
                          name="redeem_limit_amount"
                          className="form-control store_input_field"
                          placeholder="Redeem limit amount"
                          value={ADDEDITDATA?.redeem_limit_amount}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-group col-lg-3 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="contract_given_by"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          Contract Given By{" "}
                        </label>
                        <input
                          type="text"
                          id="contract_given_by"
                          name="contract_given_by"
                          className="form-control store_input_field"
                          placeholder="Contract given by"
                          value={ADDEDITDATA?.contract_given_by}
                          onChange={handleChange}
                        />
                      </div>
                    </>
                  )}

                  <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <Flex vertical gap="middle" className="">
                      <div
                        className="verndor_dashboard_add_edit_button"
                        size="large"
                      >
                        <div className="row">
                          <div className="col-lg-12 mt-5">
                            <h5>Permissions</h5>
                          </div>
                          <div
                            className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                            // onClick={() => handlePermission('customer_due', 'customer_list')}
                          >
                            <div className="vendor_dashbaord_gender_main_section all_top_and_bottom_for_input_text">
                              <label htmlFor="pickup_point_holder">
                                Pickup Point Holder
                              </label>
                              <input
                                type="checkbox"
                                id="pickup_point_holder"
                                name="pickup_point_holder"
                                value="Y"
                                className="form-check-input"
                                checked={
                                  ADDEDITDATA?.pickup_point_holder === "Y"
                                }
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          {[
                            "Retailer",
                          ].includes(ADDEDITDATA?.users_type) && (
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <div className="vendor_dashbaord_gender_main_section all_top_and_bottom_for_input_text">
                                <label htmlFor="smart_rtp_games">
                                  Enable Smart RTP Games
                                </label>
                                <input
                                  type="checkbox"
                                  id="smart_rtp_games"
                                  name="smart_rtp_games"
                                  value="Y"
                                  checked={ADDEDITDATA?.smart_rtp_games === "Y"}
                                  onChange={handleChange}
                                  className="form-check-input"
                                />
                              </div>
                            </div>
                          )}

                          {[
                            "Freelancer",
                            "Sales Person",
                            "Retailer",
                            "Promoter",
                          ].includes(ADDEDITDATA?.users_type) && (
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <div className="vendor_dashbaord_gender_main_section all_top_and_bottom_for_input_text">
                                <label htmlFor="enable_dual_login">
                                  Enable Dual Login
                                </label>
                                <input
                                  type="checkbox"
                                  id="enable_dual_login"
                                  name="enable_dual_login"
                                  value="Y"
                                  checked={ADDEDITDATA?.enable_dual_login === "Y"}
                                  onChange={handleChange}
                                  className="form-check-input"
                                />
                              </div>
                            </div>
                          )}
                          
                        </div>
                        <div className="row">
                          {ADDEDITDATA?.users_type === "Retailer" && (
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <div className="vendor_dashbaord_gender_main_section all_top_and_bottom_for_input_text">
                                <label htmlFor="enable_dis_voucher_ecomm">
                                  Enable Dis Voucher/Ecomm(Device 1)
                                </label>
                                <input
                                  type="checkbox"
                                  id="enable_dis_voucher_ecomm"
                                  name="enable_dis_voucher_ecomm"
                                  value="Y"
                                  checked={
                                    ADDEDITDATA?.enable_dis_voucher_ecomm === "Y"
                                  }
                                  onChange={handleChange}
                                  className="form-check-input"
                                />
                              </div>
                            </div>
                          )}

                          {[
                            "Freelancer",
                            "Sales Person",
                            "Retailer",
                            "Promoter",
                          ].includes(ADDEDITDATA?.users_type) && (
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <div className="vendor_dashbaord_gender_main_section all_top_and_bottom_for_input_text">
                                <label htmlFor="lotto_games">
                                  Enable Lotto Games (Device 1)
                                </label>
                                <input
                                  type="checkbox"
                                  id="lotto_games"
                                  name="lotto_games"
                                  value="Y"
                                  checked={ADDEDITDATA?.lotto_games === "Y"}
                                  onChange={handleChange}
                                  className="form-check-input"
                                />
                              </div>
                            </div>
                          )}
                          {ADDEDITDATA?.users_type === "Retailer" && (
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <div className="vendor_dashbaord_gender_main_section all_top_and_bottom_for_input_text">
                                <label 
                                  htmlFor="enable_dis_voucher_ecomm_2"
                                  style={{
                                    color: ADDEDITDATA?.enable_dual_login === "N" ? "lightgray" : ""
                                  }}
                                >
                                  Enable Dis Voucher/Ecomm (Device 2)
                                </label>
                                <input
                                  type="checkbox"
                                  id="enable_dis_voucher_ecomm_2"
                                  name="enable_dis_voucher_ecomm_2"
                                  value="Y"
                                  checked={
                                    ADDEDITDATA?.enable_dis_voucher_ecomm_2 === "Y"
                                  }
                                  disabled = {ADDEDITDATA?.enable_dual_login === "N"}
                                  style={{
                                    color: ADDEDITDATA?.enable_dual_login === "N" ? "lightgray" : ""
                                  }}
                                  onChange={handleChange}
                                  className="form-check-input"
                                />
                              </div>
                            </div>
                          )}

                          {[
                            "Freelancer",
                            "Sales Person",
                            "Retailer",
                            "Promoter",
                          ].includes(ADDEDITDATA?.users_type) && (
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <div className="vendor_dashbaord_gender_main_section all_top_and_bottom_for_input_text">
                                <label 
                                htmlFor="lotto_games_2"
                                style={{
                                    color: ADDEDITDATA?.enable_dual_login === "N" ? "lightgray" : ""
                                  }}
                                >
                                  Enable Lotto Games (Device 2)
                                </label>
                                <input
                                  type="checkbox"
                                  id="lotto_games_2"
                                  name="lotto_games_2"
                                  value="Y"
                                  checked={ADDEDITDATA?.lotto_games_2 === "Y"}
                                  disabled = {ADDEDITDATA?.enable_dual_login === "N"}
                                  style={{
                                    color: ADDEDITDATA?.enable_dual_login === "N" ? "lightgray" : ""
                                  }}
                                  onChange={handleChange}
                                  className="form-check-input"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </Flex>
                  </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="submit"
                    className="btn btn-primary inventory_save_button"
                  >
                    {" "}
                    Save{" "}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
